<template>
  <IntegrationsList :main-label="$t('connectedBanks')">
    <template v-if="providers.length">
      <IntegrationsListItem v-for="(provider,i) in providers" :key="i"
                            :provider="provider"
                            :disabled="disableButtons"
                            @edit="$emit('edit',provider)"
                            @refresh="$emit('refresh',provider)"/>
    </template>
    <div v-else class="text-md font-medium text-text-ternary leading-tight mt-4">{{ $t('noConnectedBanks') }}</div>
  </IntegrationsList>
</template>

<script>
import IntegrationsList from "@/components/cabinet/SpaceSettings/BanksIntegrations/IntegrationsList/IntegrationsList";
import IntegrationsListItem
  from "@/components/cabinet/SpaceSettings/BanksIntegrations/IntegrationsList/IntegrationsListItem";

export default {
  name: "BanksIntegrationsList",
  components: {IntegrationsListItem, IntegrationsList},
  props: {
    providers: {
      type: Array,
      required: true
    },
    disableButtons: {
      type: Boolean
    }
  },
  methods: {
    activeAccountsLength(accounts) {
      return accounts.filter(account => !!account.connected_to).length;
    }
  },
  i18n: {
    messages: {
      en: {
        connectedBanks: 'Connected banks',
        noConnectedBanks: 'No connected banks'
      },
      ru: {
        connectedBanks: 'Подключенные банки',
        noConnectedBanks: 'Нет подключенных банков'
      }
    }
  }
}
</script>